import { useEffect, useState } from 'react'
import { apiEtapa5 } from '../api'
import Aviso from '../../components/Aviso'
import { Campo, dataBR } from '../../etapa2/componentes'

const CONTRATOS = [
  ['INDETERMINADO', 'Prazo indeterminado'],
  ['EXPERIENCIA', 'Experiência'],
  ['PRAZO_DETERMINADO', 'Prazo determinado'],
  ['APRENDIZ', 'Aprendiz (FGTS 2%)'],
]
const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
const vazio = {
  funcionario_id: '', nome: '', data_admissao: '', tipo_contrato: 'INDETERMINADO', data_termino_contrato: '',
  exposicao_agente_nocivo: '', mes_data_base: '', filhos_salario_familia: [],
}

function ComplementoEmpresa({ empresaId }) {
  const [f, setF] = useState({ contribui_pis_folha: '', percentual_receita_desonerada: '100' })
  const [msg, setMsg] = useState({ erro: '', ok: '' })
  useEffect(() => {
    if (!empresaId) return
    apiEtapa5.complemento(empresaId)
      .then((c) => setF({ contribui_pis_folha: c.contribui_pis_folha === null ? '' : String(c.contribui_pis_folha), percentual_receita_desonerada: c.percentual_receita_desonerada }))
      .catch(() => setF({ contribui_pis_folha: '', percentual_receita_desonerada: '100' }))
  }, [empresaId])
  async function salvar() {
    try {
      await apiEtapa5.salvarComplemento(empresaId, {
        contribui_pis_folha: f.contribui_pis_folha === '' ? null : f.contribui_pis_folha === 'true',
        percentual_receita_desonerada: f.percentual_receita_desonerada || '100',
      })
      setMsg({ erro: '', ok: 'Complemento da empresa salvo.' })
    } catch (e) {
      setMsg({ erro: e.message, ok: '' })
    }
  }
  return (
    <>
      <h3>Empresa</h3>
      <div className="grade">
        <Campo rotulo="PIS sobre a folha (1%)">
          <select value={f.contribui_pis_folha} onChange={(e) => setF({ ...f, contribui_pis_folha: e.target.value })}>
            <option value="">Conforme o regime (imunes e isentas pagam)</option>
            <option value="true">Paga</option>
            <option value="false">Não paga</option>
          </select>
        </Campo>
        <Campo rotulo="% da receita desonerada (CPRB com atividades mistas)">
          <input type="number" min="0" max="100" step="0.01" value={f.percentual_receita_desonerada} onChange={(e) => setF({ ...f, percentual_receita_desonerada: e.target.value })} />
        </Campo>
      </div>
      <div className="acoes"><button disabled={!empresaId} onClick={salvar}>Salvar empresa</button></div>
      <Aviso>{msg.erro}</Aviso>
      <Aviso tipo="ok">{msg.ok}</Aviso>
    </>
  )
}

export default function Funcionarios({ empresaId }) {
  const [lista, setLista] = useState([])
  const [f, setF] = useState(vazio)
  const [msg, setMsg] = useState({ erro: '', ok: '' })
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })

  const carregar = () => empresaId && apiEtapa5.funcionarios(empresaId).then(setLista).catch((e) => setMsg({ erro: e.message, ok: '' }))
  useEffect(() => { carregar() }, [empresaId]) // eslint-disable-line react-hooks/exhaustive-deps

  const editar = (c) => setF({ ...vazio, ...c, data_admissao: c.data_admissao || '', data_termino_contrato: c.data_termino_contrato || '', exposicao_agente_nocivo: c.exposicao_agente_nocivo || '', mes_data_base: c.mes_data_base || '' })
  const alterarFilho = (i, k, v) => setF({ ...f, filhos_salario_familia: f.filhos_salario_familia.map((x, j) => (j === i ? { ...x, [k]: v } : x)) })

  async function salvar() {
    setMsg({ erro: '', ok: '' })
    try {
      await apiEtapa5.salvarFuncionario(empresaId, f.funcionario_id, {
        nome: f.nome,
        data_admissao: f.data_admissao || null,
        tipo_contrato: f.tipo_contrato,
        data_termino_contrato: f.data_termino_contrato || null,
        exposicao_agente_nocivo: f.exposicao_agente_nocivo || null,
        mes_data_base: f.mes_data_base ? Number(f.mes_data_base) : null,
        filhos_salario_familia: f.filhos_salario_familia.filter((x) => x.data_nascimento),
      })
      setMsg({ erro: '', ok: `Cadastro de ${f.funcionario_id} salvo.` })
      carregar()
    } catch (e) {
      setMsg({ erro: e.message, ok: '' })
    }
  }

  return (
    <section>
      <h2>Cadastro complementar</h2>
      <p className="fundamento">Dados usados pela folha integrada, férias, 13º e rescisão: aprendiz, salário-família, aposentadoria especial e data-base.</p>
      <ComplementoEmpresa empresaId={empresaId} />

      <h3>Funcionário</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Nome"><input value={f.nome} onChange={set('nome')} /></Campo>
        <Campo rotulo="Admissão"><input type="date" value={f.data_admissao} onChange={set('data_admissao')} /></Campo>
        <Campo rotulo="Tipo de contrato">
          <select value={f.tipo_contrato} onChange={set('tipo_contrato')}>
            {CONTRATOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </Campo>
        <Campo rotulo="Término previsto do contrato"><input type="date" value={f.data_termino_contrato} onChange={set('data_termino_contrato')} /></Campo>
        <Campo rotulo="Exposição a agente nocivo">
          <select value={f.exposicao_agente_nocivo} onChange={set('exposicao_agente_nocivo')}>
            <option value="">Nenhuma</option>
            <option value="25">Aposentadoria aos 25 anos (6%)</option>
            <option value="20">Aposentadoria aos 20 anos (9%)</option>
            <option value="15">Aposentadoria aos 15 anos (12%)</option>
          </select>
        </Campo>
        <Campo rotulo="Mês da data-base da categoria">
          <select value={f.mes_data_base} onChange={set('mes_data_base')}>
            <option value="">Não informado</option>
            {MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
        </Campo>
      </div>
      <h4>Filhos para salário-família</h4>
      {f.filhos_salario_familia.map((x, i) => (
        <div className="grade he" key={i}>
          <Campo rotulo="Nome"><input value={x.nome || ''} onChange={(e) => alterarFilho(i, 'nome', e.target.value)} /></Campo>
          <Campo rotulo="Nascimento"><input type="date" value={x.data_nascimento} onChange={(e) => alterarFilho(i, 'data_nascimento', e.target.value)} /></Campo>
          <label className="inline"><input type="checkbox" checked={!!x.invalido} onChange={(e) => alterarFilho(i, 'invalido', e.target.checked)} /> Inválido</label>
          <button type="button" className="link" onClick={() => setF({ ...f, filhos_salario_familia: f.filhos_salario_familia.filter((_, j) => j !== i) })}>remover</button>
        </div>
      ))}
      <div className="acoes">
        <button type="button" className="secundario" onClick={() => setF({ ...f, filhos_salario_familia: [...f.filhos_salario_familia, { nome: '', data_nascimento: '', invalido: false }] })}>+ Filho</button>
        <button disabled={!empresaId || !f.funcionario_id} onClick={salvar}>Salvar funcionário</button>
        <button type="button" className="link" onClick={() => setF(vazio)}>Novo</button>
      </div>
      <Aviso>{msg.erro}</Aviso>
      <Aviso tipo="ok">{msg.ok}</Aviso>

      {lista.length > 0 && (
        <table>
          <thead><tr><th>Matrícula</th><th>Nome</th><th>Contrato</th><th>Admissão</th><th>Filhos</th><th>Agente nocivo</th><th>Data-base</th><th></th></tr></thead>
          <tbody>
            {lista.map((c) => (
              <tr key={c.funcionario_id}>
                <td>{c.funcionario_id}</td>
                <td>{c.nome}</td>
                <td>{CONTRATOS.find((t) => t[0] === c.tipo_contrato)?.[1]}</td>
                <td>{dataBR(c.data_admissao)}</td>
                <td>{c.filhos_salario_familia.length}</td>
                <td>{c.exposicao_agente_nocivo ? `${c.exposicao_agente_nocivo} anos` : ''}</td>
                <td>{c.mes_data_base ? MESES[c.mes_data_base - 1] : ''}</td>
                <td><button type="button" className="link" onClick={() => editar(c)}>editar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  )
}
